import React, { useEffect } from 'react'
import PropTypes from 'prop-types'
import { Card, Descriptions, Layout, Row, Col, Table, Input } from 'antd'
import moment from 'moment'
import { useLocation } from 'react-router-dom'
import { connect } from 'react-redux'
import debounce from 'lodash.debounce'

import { DefaultLayout } from 'src/layouts/default'
import { Gap } from 'src/components/atoms/Gap'

export const _PreviewCouponClaimer = ({
  loading,
  meta,
  data,
  token,
  dispatch
}) => {
  const { state } = useLocation()

  useEffect(() => {
    dispatch({
      type: 'coupon_claimers/get_coupon_claimers_similar',
      payload: {
        token,
        claimerId: state?.id,
        params: { couponId: state?.couponId }
      }
    })
  }, [])

  const onHandleSearch = (e) => {
    const { target } = e

    dispatch({
      type: 'coupon_claimers/get_coupon_claimers_similar',
      payload: {
        token,
        claimerId: state?.id,
        params: {
          q: target.value,
          couponId: state?.couponId
        }
      }
    })
  }

  const onHandlePaginate = (page, pageSize) => {
    dispatch({
      type: 'coupon_claimers/get_coupon_claimers_similar',
      payload: {
        token,
        claimerId: state?.id,
        params: { page: page, couponId: state?.couponId }
      }
    })
  }

  const columns = [
    {
      title: 'No',
      dataIndex: 'no',
      align: 'center',
      width: 20,
      render: (text, obj, index) => <a>{index + 1}</a>,
      fixed: 'left'
    },
    {
      title: 'Unique Code',
      dataIndex: 'id',
      align: 'center',
      render: (text, obj) => <a>{obj.trackId}</a>
    },
    {
      title: 'Name',
      dataIndex: 'name',
      align: 'center'
    },
    {
      title: 'Email',
      dataIndex: 'email',
      align: 'center',
      render: (email) => <>{email ?? '-'}</>
    },
    {
      title: 'Entered At',
      dataIndex: 'createdAt',
      align: 'center',
      render: (date) => <>{moment(date).format('DD-MM-YYYY, HH:mm')} WIB</>
    },
    {
      title: 'Used',
      dataIndex: 'isUsed',
      align: 'center',
      render: (txt) => <>{txt ? 'Dipakai' : 'Belum Dipakai'}</>
    }
  ]

  return (
    <DefaultLayout>
      <Layout.Content className='container-detail-product'>
        <Card>
          <Row>
            <Col span={16}>
              <Descriptions title='Detail Coupon Claimer:'>
                <Descriptions.Item label='Phone'>
                  {state.phone}
                </Descriptions.Item>
                <Descriptions.Item label='Total Claim'>
                  {data?.length ?? 0}
                </Descriptions.Item>
                <Descriptions.Item label='Batch No'>
                  {state.customCode || '-'}
                </Descriptions.Item>
              </Descriptions>
            </Col>
            <Col span={8}>
              <Input
                allowClear
                onChange={debounce(onHandleSearch, 500)}
                placeholder='Search'
              />
            </Col>
          </Row>
          <Gap height='1rem' />
          <Table
            rowKey='id'
            columns={columns}
            dataSource={data ?? []}
            rowSelection={{
              type: 'checkbox'
            }}
            loading={loading}
            scroll={{ x: 'max-content' }}
            pagination={
              meta && {
                defaultPageSize: meta.itemsPerPage,
                total: meta.totalItems,
                pageSize: meta.itemsPerPage,
                onChange: (page, pageSize) => onHandlePaginate(page, pageSize)
              }
            }
          />
        </Card>
      </Layout.Content>
    </DefaultLayout>
  )
}

const mapStateToProps = ({ reducerCouponClaimers }) => {
  return { ...reducerCouponClaimers }
}

export const PreviewCouponClaimer = connect(mapStateToProps)(
  _PreviewCouponClaimer
)

_PreviewCouponClaimer.propTypes = {
  dispatch: PropTypes.func,
  token: PropTypes.string,
  loading: PropTypes.bool,
  meta: PropTypes.object,
  data: PropTypes.oneOfType([PropTypes.instanceOf(Object), PropTypes.array])
}
